module.exports = __webpack_public_path__ + "static/media/speed-fibre.f0dfc31d.png";